module.exports = __webpack_public_path__ + "img/ey-logo.1ae8fa8c.svg";